export default "__VITE_ASSET__3393e44d__"